import React from 'react';

export default function SpeciesListEntry(props: any) {
  function handleClick() {
    props.onSelected(props.item);
  }

  return (
    <li className='species-list-item' onClick={handleClick}>
      <div className='species-list-item-details'>
        <span className='species-list-item-title'>{props.item.name}</span>
        <span className='species-list-item-meta'>Latest Ping: {props.lastPing}d ago</span>
      </div>
      <span className='species-list-item-arrow' aria-hidden='true'>&gt;</span>
    </li>
  )
}